/** GET paths used by the ROOT org switcher — 401 here means switching is unavailable, not logout. */
export function isOrgSwitcherReadRequest(url) {
  if (!url) {
    return false;
  }
  const path = url.split('?')[0].replace(/\/$/, '') || '/';
  return path === '/org/all' || path === '/org';
}
